import consumer from './action_cable_consumer'

(function ($) {
  $(function() {
    var requestID = null;
    // INIT the Susbcription Plans - New/Edit Page
    if ($('.admin_subscriptions') != null ) {
      // INIT subscription listener
      var csvDownloadChannel = consumer.subscriptions.create({ channel: 'ActiveAdmin::SubscriptionsCsvDownloadChannel' }, {
        received(data) {
          this.promptCSVDwonload(data)
        },
        promptCSVDwonload(data) {
          // remove loader
          $.modal.close();

          // Only trigger in the same browser window
          if(data['request_id'] != requestID){
            return
          }

          if (data['success']) {
            let downloadUrl = data['csv_url']
            let fileName = data['file_name']
            // OK. I know this is a bit weird!
            // The only way at the moment to force the attachment download in the same window with no refresh is creating a link with
            // download attribute and clicking on it.
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadUrl;
            a.download = fileName;
            a.click();
          }
          else {
            alert('Error generating CSV:' + data['error'])
          }
        }
      });

      $('.subscriptions_csv_download').click(function(e) {
        e.preventDefault()
        // trigger loader msg
        $("<div><p class='align-center'>CSV Download Started. Please wait, will be ready shorty ... </p></div>").modal()

        // generate request ID
        requestID = Math.random().toString(36).slice(2, 8);

        // trigger websocket push
        let urlParams = new URLSearchParams(window.location.search)
        csvDownloadChannel.send({ 
          request_id: requestID,
          query_string: urlParams.toString(),
        })
      });
    }
  })
})(jQuery);
